import React from 'react';
import BookButton from '../../Shared/BookButton';
import experts from '../../../img/experts.png';
import experts1 from '../../../img/expert-1.png';
import experts2 from '../../../img/expert-2.png';
import experts3 from '../../../img/expert-3.png';

const IndustryExperts = () => {
  return (
    <div className='px-4 md:px-12 grid md:flex md:flex-row-reverse grid-cols-1 gap-8 md:py-20 py-16 md:items-center'>
      <div className='flex-1 relative' >
        <img className='mx-auto' src={experts} alt="" />
        <div className='bg-white shadow-xl rounded-md py-1 px-4 absolute top-4 right-6 flex items-center '>
          <img src={experts3} alt="" className='w-16 mr-2' />
          <p>Qualified Mentors</p>
        </div>
        <div className='bg-white shadow-xl rounded-md py-1 px-4 absolute bottom-2 left-8 flex items-center '>
          <img src={experts2} alt="" className='w-16 mr-2' />
          <p>1:1 Counseling</p>
        </div>
        <div className='bg-white shadow-xl rounded-md py-1 px-4 absolute bottom-2 right-6 flex items-center'>
          <img src={experts1} alt="" className='w-16 mr-2' />
          <p>Best Analysis</p>
        </div>
      </div>
      <div className='flex-1'>
        <h1 className='text-2xl md:text-3xl font-semibold '>The Largest Community of <br /> <span className='text-blue-500'>Industry experts & Counselors</span> in India</h1>
        <p className='text-[17px] mt-8 text-left'>We help students and provide live mentorship sessions to achieve their goals and find a best career</p>
        <BookButton name="Book A Free Session" />
      </div>
    </div>
  );
};

export default IndustryExperts;